import { Type } from '@angular/core';

import { JobLogViewerComponent } from './job-log-viewer.component';

export * from './job-log-viewer.component';

export const JOB_LOG_VIEWER_DIRECTIVES: Type<any>[] = [
  JobLogViewerComponent
];
